import { NS } from '../U3120Constants';
import type { U3120CustomerEmployeeRate } from '../U3120Service';
import type { U3120Translate } from './U3120CustomerValidation';

const ns = { ns: NS };

export function u3120FindDuplicateEmployeeRate(
  rates: U3120CustomerEmployeeRate[],
  employeeId: string | undefined,
  excludeId?: string,
): U3120CustomerEmployeeRate | undefined {
  if (!employeeId) {
    return undefined;
  }
  return rates.find((item) => item.employee?.id === employeeId && item.id !== excludeId);
}

export function u3120ValidateCustomerEmployeeRate(
  customerEmployeeRate: U3120CustomerEmployeeRate,
  existingRates: U3120CustomerEmployeeRate[],
  t: U3120Translate,
): Record<string, string> {
  const result: Record<string, string> = {};
  if (!customerEmployeeRate.employee || !customerEmployeeRate.employee.id || customerEmployeeRate.employee.id === '') {
    result['employee.id'] = t('errEmployeeRequired', ns);
  }
  if (customerEmployeeRate.hourRate === null || customerEmployeeRate.hourRate === undefined || customerEmployeeRate.hourRate < 0) {
    result.hourRate = t('errHourRateRequired', ns);
  }
  if (customerEmployeeRate.validFrom === undefined || customerEmployeeRate.validFrom === null || String(customerEmployeeRate.validFrom).trim() === '') {
    result.validFrom = t('errValidFromRequired', ns);
  }
  const validFromStr = customerEmployeeRate.validFrom ? String(customerEmployeeRate.validFrom).trim() : '';
  const validToStr = customerEmployeeRate.validTo != null ? String(customerEmployeeRate.validTo).trim() : '';
  if (validFromStr && validToStr && validToStr < validFromStr) {
    result.validTo = t('errValidToBeforeValidFrom', ns);
  }
  const duplicate = u3120FindDuplicateEmployeeRate(existingRates, customerEmployeeRate.employee?.id, customerEmployeeRate.id);
  if (duplicate) {
    result['employee.id'] = t('errCustomerEmployeeRateDuplicate', ns);
  }
  return result;
}
